"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HAS_FORM_DATA = void 0;

var _getWindowObject = require("./get-window-object");

/**
 * Safely check if the window exists and supports form data
 */
var HAS_FORM_DATA = !!(0, _getWindowObject.getWindowObject)('FormData');
exports.HAS_FORM_DATA = HAS_FORM_DATA;
//# sourceMappingURL=has-form-data.js.map